import { render } from "./ModalAdminAffiliate.vue?vue&type=template&id=b3e4da60&scoped=true"
import script from "./ModalAdminAffiliate.vue?vue&type=script&lang=js"
export * from "./ModalAdminAffiliate.vue?vue&type=script&lang=js"

import "./ModalAdminAffiliate.vue?vue&type=style&index=0&id=b3e4da60&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3e4da60"]])

export default __exports__